import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicComponent } from 'src/app/shared-module/layout/public/public.component';
import { AppRoutingModule } from 'src/app/root-module/app-routing.module';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from '../login/login.component';
import { ResetPasswordComponent } from '../reset-password/ResetPasswordComponent';
import { ToastrComponent } from 'src/app/shared-module/components/toastr/toastr.component';
import { TrialComponent } from '../trial/trial.component';
import { TrialSuccessComponent } from '../trial-success/trial-success.component';
import { ShowTrialComponent } from '../show-trial/show-trial.component';
import { DemoSuccessComponent } from '../demo-success/demo-success.component';
import { PublicAuditComponent } from '../public-audit/public-audit.component';
import { PublicAuditQuestionComponent } from '../public-audit/public-audit-question/public-audit-question.component';
import { RadioButtonComponent } from '../public-audit/question-templates/radio-button/radio-button.component';
import { DropdownComponent } from '../public-audit/question-templates/dropdown/dropdown.component';
import { CheckboxComponent } from '../public-audit/question-templates/checkbox/checkbox.component';
import { DateComponent } from '../public-audit/question-templates/date/date.component';
import { TextComponent } from '../public-audit/question-templates/text/text.component';
import { SharedComponentsModule } from 'src/app/shared-module/shared-components/shared-components.module';
import { OptOutComponent } from '../public-audit/opt-out/opt-out.component';

@NgModule({
  declarations: [
    PublicComponent,
    LoginComponent,
    ResetPasswordComponent,
    TrialComponent,
    TrialSuccessComponent,
    ShowTrialComponent,
    DemoSuccessComponent,
    PublicAuditComponent,
    PublicAuditQuestionComponent,
    RadioButtonComponent,
    DropdownComponent,
    CheckboxComponent,
    DateComponent,
    TextComponent,
    OptOutComponent
  ],
  imports: [
    SharedComponentsModule

  ]
})
export class PublicComponentsModule { }
